import {createActorContext} from '@xstate/react';
import React from 'react';
import {Edge, Node} from 'reactflow';

import {LayoutSettings} from 'ui-library/reactflow/layout/calculateDimensionsForLayout';

import {EntityMap_entityMap_EntityMapNode_entities as EntityMapEntityNodeOrInaccessibleInfoNode} from './__generated/EntityMap';
import {EntityMapMachine} from './EntityMapMachine';

// Create the actor context for the EntityMapMachine
export const EntityMapMachineContext = createActorContext(EntityMapMachine);
export const useEntityMapActorRef = EntityMapMachineContext.useActorRef;
export const useEntityMapSelector = EntityMapMachineContext.useSelector;

// Provider component to wrap the subtree
export const EntityMapMachineProvider = ({
  entityId,
  layoutSettings,
  excludedSchemaIds,
  userExpandedEntityIds,
  children,
}: {
  entityId: string;
  layoutSettings: Partial<LayoutSettings<Node<EntityMapEntityNodeOrInaccessibleInfoNode>, Edge>>;
  excludedSchemaIds: Array<string>;
  userExpandedEntityIds?: Array<string>;
  children: React.ReactNode;
}): JSX.Element => (
  <EntityMapMachineContext.Provider
    options={{input: {entityId, layoutSettings, excludedSchemaIds, userExpandedEntityIds}}}
  >
    {children}
  </EntityMapMachineContext.Provider>
);
